import fetch from '../../api/fetch'

/**
 *
 *  Action to check which step a specific quote is
 *  to prevent users to navigate backwards
 *
 *  @param  {string} URL [/api/v1/quotes/:quoteId/check_step]
 *  @method GET
 */
export function checkQuoteStep(quoteId: number) {
    return {
        type: 'CHECK_QUOTE_STEP',
        payload: fetch(`/quotes/${quoteId}/check_step`, { method: 'GET' }),
    }
}

export function resetQuotes() {
    return {
        type: 'RESET_QUOTES',
    }
}

export function resetStep() {
    return {
        type: 'RESET_STEP',
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/quote/quote.ts